module.exports = __webpack_public_path__ + "img/envelope.a2da78b4.svg";